/**
 * Hook to check if the user is logged in via email AND is on a mobile device.
 * Always returns false since email login is no longer supported (Privy removed).
 */
export function useIsMobileEmailUser(): boolean {
  return false
}
